import { Directive, HostListener, Input } from '@angular/core';
import { EguardNavbarVerticalService } from './navbar-vertical.service';
import { EguardNavbarVerticalComponent } from './navbar-vertical.component';

@Directive({
    selector: '[eguardNavbarVertical]'
})
export class EguardNavbarVerticalToggleDirective
{
    @Input() eguardNavbarVertical: string;
    navbar: EguardNavbarVerticalComponent;

    constructor(private navbarService: EguardNavbarVerticalService)
    {
    }

    @HostListener('click')
    onClick()
    {
        this.navbar = this.navbarService.getNavBar();

        if ( !this.navbar[this.eguardNavbarVertical] )
        {
            return;
        }

        this.navbar[this.eguardNavbarVertical]();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/components/navbar/vertical/navbar-vertical-toggle.directive.ts